import { App } from 'vue'
import registerLoading from './loading'

export default function registerDirectives(app: App) {
  registerLoading(app)
}
